/**
 * form-validator functions
 */
import isEmpty from 'validator/lib/isEmpty'

export const validatePassword = (password: string): string[] => {
  const issues = []

  if (isEmpty(password)) {
    issues.push('Please type in a password')
  }

  if (!/[a-z]/.test(password)) {
    issues.push('At least one lowercase letter')
  }

  if (!/[A-Z]/.test(password)) {
    issues.push('At least one uppercase letter')
  }

  if (!/[0-9]/.test(password)) {
    issues.push('At least one digit')
  }

  if (password.length < 8) {
    issues.push('At least 8 characters')
  }

  return issues
}

export const validateBusinessDomain = (domain: string): string[] => {
  const issues = []

  const businessDomainCheck = /^(?!@(gmail|google|yahoo|outlook|hotmail|msn|qq)\..+)(@.+\..+)$/
  const domainCheck = /^(@.+\..+)$/
  if (!domainCheck.test(domain)) {
    issues.push('Please input correct domain format')
  } else if (!businessDomainCheck.test(domain)) {
    issues.push('Please input business domain')
  }

  return issues
}

/**
 * Validates that a URL can be used to connect to an external model.
 * @param url
 * @returns
 */
export const validateUrl = (url: string): string[] => {
  const issues = []

  const protocolCheck = /^(http(s)?:\/\/)/
  if (!protocolCheck.test(url)) {
    issues.push('Invalid URL - please include a valid protocol (http:// or https://)')
  }

  const urlCheck =
    // eslint-disable-next-line no-useless-escape
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
  if (!urlCheck.test(url)) {
    issues.push('Invalid URL - please check the format')
  }

  return issues
}

/**
 * Validates that a name can be given to an external model
 * @param name - The name the user has chosen
 * @param otherModelNames - The names of all other external models for this team
 */
export const validateExternalModelName = (name: string, otherModelNames: string[]): string[] => {
  const issues = []

  if (isEmpty(name)) {
    issues.push('Please enter a name')
  }

  if (otherModelNames.includes(name)) {
    issues.push('A model already exists with this name')
  }

  return issues
}

/**
 * Utility function to ensure that a value is never reached.
 * Comes handy to make switch statements exhaustive.
 *
 * @param value - The value that should never be reached
 */
export const never = (value: never): never => {
  throw new Error(`This should never be reached. It was reached with value: ${value}`)
}
